module.exports = __webpack_public_path__ + "static/media/ring.91e45b81.mp3";